import { INTENDED_ROUTE_KEY } from "./authConstants";

const PUBLIC_AUTH_PATHS = new Set(["/login", "/signup"]);

export function getCurrentFullPath() {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function saveIntendedRoute(value = getCurrentFullPath()) {
  if (typeof window === "undefined") return value;
  const path = value && value.startsWith("/") ? value : "/";
  if (!PUBLIC_AUTH_PATHS.has(path.split(/[?#]/)[0])) {
    window.sessionStorage.setItem(INTENDED_ROUTE_KEY, path);
  }
  return path;
}

export function readIntendedRoute(fallback = "/listOrganization") {
  if (typeof window === "undefined") return fallback;
  const statePath = window.history.state?.usr?.from;
  const normalizedStatePath = typeof statePath === "string"
    ? statePath
    : statePath?.pathname
      ? `${statePath.pathname}${statePath.search || ""}${statePath.hash || ""}`
      : "";
  return normalizedStatePath || window.sessionStorage.getItem(INTENDED_ROUTE_KEY) || fallback;
}

export function consumeIntendedRoute(fallback = "/listOrganization") {
  const route = readIntendedRoute(fallback);
  if (typeof window !== "undefined") window.sessionStorage.removeItem(INTENDED_ROUTE_KEY);
  return route;
}
